import { createContext, useContext } from 'react';
import { Mitarbeiter } from '../types';

export interface AuthContextType {
  user: Mitarbeiter | null;
  loading: boolean;
  login: (email: string, password: string, totp_code?: string) => Promise<void>;
  logout: () => Promise<void>;
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  loading: true,
  login: async () => {},
  logout: async () => {},
  refreshUser: async () => {},
});

export const useAuth = () => useContext(AuthContext);
